import clsx from 'clsx';
import styles from './Burble.module.css';
import React from 'react';
import carret from '../../../assets/img/bubble_carret.png';

/**
 * Bubble message with small triangle carret in the bottom of it.
 * @param props
 * @constructor
 */
export const Burble = (props: any) => {
  return (
    <div className={clsx(styles.burble, 'position-relative')}>
      {props.children}
      <div className={clsx(styles.carret)} style={{ background: `url(${carret})` }}></div>
    </div>
  );
};
